<template>
    <v-flex
        v-if="display"
        xs12
        class="px-12 py-6"
        :style="{backgroundColor: bgColor}"
        tabindex="0"
    >
        <v-divider aria-hidden="true" class="my-4" />
        <span class="coupon-label subheading">
            {{ $t('coupon.instructions') }}
        </span>
        <div
            class="pt-2 coupon-details service-details"
            v-html="localeCoupon" />
        <div v-if="service['document' + upperLocale]" class="text-right">
            <v-btn
                class="pa-0 ma-0"
                icon
                text
                color="primary"
                large
                :href="localeAttachment"
                target="_blank"
                id="coupon-pdf-btn"
            >
                <v-icon medium>
                    far fa-file-pdf
                </v-icon>
            </v-btn>
        </div>
    </v-flex>
</template>

<script>
import { mapGetters } from 'vuex';
import { shadeColor } from '@/utils';
export default {
    name: 'coupon-service-details',
    props: {
        service: { type: Object, required: true },
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),

        /**
         * Returns a shaded color based on the primary color
         */
        bgColor() {
            return shadeColor(this.$vuetify.theme.themes.light.primary, 0.92);
        },

        /**
         * Returns true if we display the service coupon message
         */
        display() {
            return this.service && this.service.enableCoupon && this.service[`coupon${this.upperLocale}`];
        },

        localeCoupon() {
            return this.display
                ? this.service[`coupon${this.upperLocale}`]
                : '';
        },

        hasAttachment() {
            return this.service && this.service[`document${this.upperLocale}`];
        },

        localeAttachment() {
            return this.hasAttachment
                ? this.service[`document${this.upperLocale}`]
                : '';
        },
    },
};
</script>
